import _ from 'lodash';

export default function isSellerCloudVendorOrder(order) {
	return order && order.channel && order.channel.shipmentDocumentPullSource ? order.channel.shipmentDocumentPullSource.toLowerCase() === 'sellercloud' : false;
}
